/**
 * Coupon Service
 */
import { getApiClient } from '../apiClient';
import { COUPON_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
  GetCouponsResponse,
  GetCouponsParams,
  GetCouponResponse,
  CreateCouponPayload,
  CreateCouponResponse,
  UpdateCouponPayload,
  UpdateCouponResponse,
  DeleteCouponResponse,
} from '../types/coupon.types';

export const couponService = {
  /**
   * Get all coupons with pagination and search
   */
  getCoupons: (params?: GetCouponsParams): Promise<GetCouponsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) {
      queryParams.append('page', String(params.page));
    }
    if (params?.limit) {
      queryParams.append('limit', String(params.limit));
    }
    if (params?.offset) {
      queryParams.append('offset', String(params.offset));
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.status !== undefined) {
      queryParams.append('status', String(params.status));
    }
    if (params?.valueType) {
      queryParams.append('valueType', String(params.valueType));
    }
    if (params?.option) {
      queryParams.append('option', String(params.option));
    }
    const url = queryParams.toString()
      ? `${COUPON_ENDPOINTS.getCoupons}?${queryParams.toString()}`
      : COUPON_ENDPOINTS.getCoupons;
    return getApiClient().get(url);
  },

  /**
   * Get single coupon by ID
   */
  getCoupon: (id: string): Promise<GetCouponResponse> => {
    const url = replacePathParams(COUPON_ENDPOINTS.getCoupon, { id });
    return getApiClient().get(url);
  },

  /**
   * Create coupon
   */
  createCoupon: (body: CreateCouponPayload): Promise<CreateCouponResponse> => {
    return getApiClient().post(COUPON_ENDPOINTS.createCoupon, body);
  },

  /**
   * Update coupon
   */
  updateCoupon: (id: string, body: UpdateCouponPayload): Promise<UpdateCouponResponse> => {
    const url = replacePathParams(COUPON_ENDPOINTS.updateCoupon, { id });
    return getApiClient().put(url, body);
  },

  /**
   * Delete coupon
   */
  deleteCoupon: (id: string): Promise<DeleteCouponResponse> => {
    const url = replacePathParams(COUPON_ENDPOINTS.deleteCoupon, { id });
    return getApiClient().delete(url);
  },
};

